const baseWidth = 1920; // 默认基准宽度

function zoomReset() {
	const windowWidth = document.documentElement.clientWidth;
	const zoom = windowWidth / baseWidth;

	document.documentElement.style.setProperty("--zoom", zoom);
	// 以1920为定宽，做zoom计算；高度为视窗100vh，由于有放大缩小，所以实际高度需要 / zoom
	const body = document.getElementsByTagName("body")[0];
	body.style.width = `${baseWidth}px`;
	body.style.height = `calc(100vh / ${zoom})`;
}

export function zoomInit() {
	zoomReset();
	window.addEventListener("resize", zoomReset);
}
